export default "<span class=\"label label-lg label-inline\" [ngClass]=\"getStatusCSS()\">{{ getStatusLabel() }}</span>\n";